<template>
      <div class="titolo-card">
        <h1>Gestione Sedute PT</h1>
        <h3>Qui troverai tutte le sedute effettuate e da effettuare.</h3>
      </div>

      <!-- Bottone per aprire il modale -->
      <button @click="showModal = true" class="create-user-button staff-button-positive">
        Crea Seduta PT
      </button>

      <!-- Modale con soli 2 campi -->
      <div v-if="showModal" class="modal">
        <div class="modal-content">
          <span class="close" @click="closeModal">&times;</span>
          <h2>Crea Seduta PT</h2>
          <form @submit.prevent="addSeduta">
            <label for="categoriaSeduta">Tipo Seduta:</label>
            <select id="categoriaSeduta" v-model="newSeduta.categoriaSeduta">
              <option value="">Seleziona tipo</option>
              <option value="studio">Studio</option>
              <option value="online">Oline</option>
            </select>

            <label for="numeroSedute">Quante Sedute:</label>
            <select id="numeroSedute" v-model.number="newSeduta.numeroSedute">
              <option value="">Seleziona numero</option>
              <option v-for="num in 50" :key="num" :value="num">{{ num }}</option>
            </select>

            <button class="staff-button-positive" type="submit">Salva Seduta</button>
          </form>
        </div>
      </div>


<!-- Storico sedute PT (demo) -->
<section class="sedutept-storico">
  <h1>Sedute PT storiche importate</h1>
  <div class="storico-box">
    <div class="storico-head">
      <div>Nome pacchetto</div>
      <div>Sedute acquistate</div>
      <div>Sedute fatte</div>
    </div>
    <div
      v-for="row in seduteStoricoRows"
      :key="row.id"
      class="storico-row"
    >
      <div>{{ row.label }}</div>
      <div>{{ row.totale }}</div>
      <div>{{ row.fatte }}</div>
    </div>
    <div v-if="seduteStoricoRows.length === 0" class="storico-row">
      <div class="muted">Nessuna seduta importata.</div>
      <div>—</div>
      <div>—</div>
    </div>
  </div>
</section>

      <!-- Tabella: visualizza il documento e, sotto, le righe per ciascun slot -->
      <div class="consulenze-container">
        <h1>Sedute PT</h1>
        <table>
          <thead>
            <tr>
              <th> </th>
              <th>Data</th>
              <th>Status</th>
              <th>Data Effettuata</th>
              <th>Come</th>
              <th>Professionista</th>
              <th>Note</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="seduta in sedute" :key="seduta.id">
              <!-- Riga intestazione del documento -->
              <tr class="header-row">
                <td colspan="6">
                  {{ seduta.categoriaSeduta ? seduta.categoriaSeduta.toUpperCase() : '' }}
                </td>
              </tr>
              <!-- Righe per ogni slot -->
              <tr v-for="(slot, index) in seduta.slots" :key="index">
                <td></td>
                <td>{{ formatDate(slot.dataCreazioneslot) }}</td>
                <td>
                  <select
                    :value="slot.status"
                    @change="updateSlotField($event, seduta, index, 'status')">
                    <option value="Da contattare">Da contattare</option>
                    <option value="In attesa di risposta">In attesa di risposta</option>
                    <option value="Prenotata">Prenotata</option>
                    <option value="Fatta">Fatta</option>
                  </select>
                </td>
                <td>
                  <input
                    type="date"
                    :value="formatInputDate(slot.dataEffettuata)"
                    @change="updateSlotField($event, seduta, index, 'dataEffettuata')" />
                </td>
                <td>
                  <select
                    :value="slot.come"
                    @change="updateSlotField($event, seduta, index, 'come')">
                    <option value="online">Online</option>
                    <option value="instudio">In Studio</option>
                  </select>
                </td>
                <td>
                  <input
                    type="text"
                    :value="slot.TrainerNome"
                    @change="updateSlotField($event, seduta, index, 'TrainerNome')" />
                </td>
                <td>
                  <input
                    type="text"
                    :value="slot.note"
                    @change="updateSlotField($event, seduta, index, 'note')" />
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

</template>

<script>
import { ref, watch, onBeforeUnmount, computed } from 'vue';
import {
  getFirestore,
  collection,
  addDoc,
  query,
  onSnapshot,
  updateDoc,
  doc,
  where
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

export default {
  name: "SedutePTComponent",
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const db = getFirestore();
    const auth = getAuth();
    const showModal = ref(false);
    const sedute = ref([]);
    let unsubscribe = null;

    // Dati del form per la nuova seduta
    const newSeduta = ref({
      categoriaSeduta: '',
      numeroSedute: null,
    });

    const closeModal = () => {
      showModal.value = false;
      newSeduta.value = { categoriaSeduta: '', numeroSedute: null };
    };

    // Genera un id random
const generateRandomId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return Math.random().toString(36).substr(2, 9);
};
    // Crea un documento con un array di slot (uno per ciascuna seduta)
    const addSeduta = async () => {
      if (!newSeduta.value.categoriaSeduta || !newSeduta.value.numeroSedute) {
        alert("Completa tutti i campi richiesti.");
        return;
      }
      const num = newSeduta.value.numeroSedute;
      const slots = [];
      const nowIso = new Date().toISOString();
      const isOnline = String(newSeduta.value.categoriaSeduta || '').toLowerCase() === 'online';
      for (let i = 0; i < num; i++) {
        slots.push({
          dataCreazioneslot: nowIso,
          dataEffettuata: null,
          TrainerNome: '',
          note: '',
          status: 'Da contattare',
          come: isOnline ? 'online' : 'instudio'
        });
      }
      try {
        await addDoc(collection(db, "sedutept"), {
          uid: props.userId,
          creatorUid: auth.currentUser?.uid || null,
          categoriaSeduta: newSeduta.value.categoriaSeduta,
          numeroSedute: num,
          slots,
          idSeduteGroup: generateRandomId(),
          createdAt: nowIso
        });
        alert("Seduta/e creata/e con successo!");
        closeModal();
      } catch (error) {
        console.error("Errore nel salvataggio delle sedute PT:", error);
        alert("Errore nel salvataggio.");
      }
    };

    // Recupera le sedute dalla collection 'sedutept' filtrando per uid
    const fetchSedute = () => {
      if (unsubscribe) {
        unsubscribe();
        unsubscribe = null;
      }
      const seduteQuery = query(
        collection(db, "sedutept"),
        where("uid", "==", props.userId)
      );
      unsubscribe = onSnapshot(seduteQuery, (querySnapshot) => {
        sedute.value = querySnapshot.docs.map(d => ({
          id: d.id,
          ...d.data()
        }));
      }, (err) => {
        console.error("Errore nel recupero sedute PT:", err);
      });
    };

    const toMillis = (value) => {
      if (value == null) return NaN;
      if (typeof value?.toMillis === 'function') {
        try { return value.toMillis(); } catch { return NaN; }
      }
      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? NaN : date.getTime();
    };

    const isSlotDone = (slot) => {
      if (!slot) return false;
      const status = String(slot.status || '').toLowerCase();
      if (status === 'fatta') return true;
      return !!slot.dataEffettuata;
    };

    const seduteStoricoRows = computed(() => {
      const rows = (sedute.value || [])
        .map((docItem) => {
          const slots = Array.isArray(docItem.slots) ? docItem.slots : [];
          const total = Number(docItem.numeroSedute);
          const totale = Number.isFinite(total) && total > 0 ? total : slots.length;
          const fatte = slots.filter(isSlotDone).length;
          return {
            id: docItem.id,
            label: docItem.productName || docItem.categoriaSeduta || 'Sedute PT',
            totale,
            fatte,
            createdAt: docItem.createdAt || null
          };
        });

      return rows.sort((a, b) => {
        const at = toMillis(a.createdAt);
        const bt = toMillis(b.createdAt);
        if (Number.isNaN(at) && Number.isNaN(bt)) return 0;
        if (Number.isNaN(at)) return 1;
        if (Number.isNaN(bt)) return -1;
        return bt - at;
      });
    });

    onBeforeUnmount(() => {
      if (unsubscribe) unsubscribe();
    });

    // Utilità date
    const formatDate = (dateStr) => {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      if (isNaN(date)) return "";
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const yyyy = date.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    };

    const formatInputDate = (dateStr) => {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      if (isNaN(date)) return "";
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    };

    // Aggiorna un campo specifico di uno slot
    const updateSlotField = async (event, sedutaDoc, slotIndex, field) => {
      const newValue = event.target.value;
      const updatedSlots = Array.isArray(sedutaDoc.slots) ? [...sedutaDoc.slots] : [];
      updatedSlots[slotIndex] = { ...updatedSlots[slotIndex], [field]: newValue };
      try {
        await updateDoc(doc(db, "sedutept", sedutaDoc.id), { slots: updatedSlots });
      } catch (error) {
        console.error(`Errore aggiornando il campo ${field} dello slot:`, error);
        alert("Errore nell'aggiornamento del campo.");
      }
    };

    // Avvio / re-fetch al cambio userId
    watch(() => props.userId, (newUserId) => {
      if (newUserId) fetchSedute();
    }, { immediate: true });

    return {
      showModal,
      newSeduta,
      addSeduta,
      closeModal,
      sedute,
      seduteStoricoRows,
      formatDate,
      formatInputDate,
      updateSlotField
    };
  }
};
</script>

<style scoped>

/* Storico sedute PT (demo) */
.sedutept-storico {
  margin: 56px 0 74px;
}


.storico-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
}

.storico-head,
.storico-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0;
}

.storico-head {
  background: #f7f7f7;
  font-weight: 600;
}

.storico-head > div,
.storico-row > div {
  padding: 10px 12px;
  border-bottom: 1px solid #eee;
}

.storico-row:last-child > div {
  border-bottom: none;
}

.create-consulenza-button {
  margin-bottom: 20px;
  padding: 10px 20px;
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  margin-left: 120px;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
}
.modal-content {
  margin: 10% auto;
  padding: 20px;
  width: 50%;
  position: relative;
}
.close {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 24px;
  cursor: pointer;
}
.consolenze-container,
.consolenze-container h1 {
  margin-top: 20px;
}
table {
  width: 99%;
  margin-bottom: 100px;
}
th, td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;

}
.header-row {
  background-color: #f0f0f0;
  font-weight: bold;
}
</style>
